import { render, staticRenderFns } from "./DeliverySpaceUpdate.vue?vue&type=template&id=7bbd3a82&"
import script from "./DeliverySpaceUpdate.vue?vue&type=script&lang=ts&"
export * from "./DeliverySpaceUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports